import React, { useEffect, useState } from 'react';
import './welcome.css';
import AdharVerify from './adharOtpModal/AdharVerify';
import { AiFillSafetyCertificate } from 'react-icons/ai';
import verifiedIcon from '../../assets/images/check-circle-svgrepo-com.svg';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import axiosRetry from 'axios-retry';
import API_URL from '../../utility/api';
import { useData } from '../../context/AdharDataContext';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Dropdown from '../dropdown/Dropdown';

// Configure axios-retry
axiosRetry(axios, { retries: 3, retryDelay: (retryCount) => retryCount * 1000 });

function Welcome() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { userData, setUserData, setAdharData } = useData();
    const [showAdharVerify, setShowAdharVerify] = useState(false);
    const [buttonDisabled, setButtonDisabled] = useState(true);
    const [panValue, setPanValue] = useState('');
    const [adhaarValue, setAdhaarValue] = useState('');
    const [checkbox1Checked, setCheckbox1Checked] = useState(false);
    const [checkbox2Checked, setCheckbox2Checked] = useState(false);
    const [isVerified, setIsVerified] = useState(false);
    const [isPANVerified, setIsPANVerified] = useState(false);
    const [isPANInvalid, setIsPANInvalid] = useState(false);
    const [isAadharInvalid, setIsAadharInvalid] = useState(false);
    const [isAadhaarEdited, setIsAadhaarEdited] = useState(false);
    const [aadharVerified, setAadharVerified] = useState(false);
    const [otpData, setOtpData] = useState(null);
    const [responseFromAPI, setResponseFromAPI] = useState(null);
    const [loading, setLoading] = useState(false);
    const [branchOptions, setBranchOptions] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState(null);

    const handleAPIResponse = (responseData) => {
        if (!responseData) {
            console.error('Received null or undefined API response');
            toast.error('Invalid response from server');
            return;
        }
        setResponseFromAPI(responseData);
    };

    useEffect(() => {
        if (responseFromAPI) {
            console.log('API Response Updated:', responseFromAPI);
        }
    }, [responseFromAPI]);

    useEffect(() => {
        const fetchBranches = async () => {
            try {
                const response = await axios.get(API_URL + '/MasterData/GetBranchesTypes?bankId=-1', {
                    timeout: 10000,
                    headers: { 'Content-Type': 'application/json' },
                });
                console.log('Branches API Response:', response.data);

                let branchData = response.data;
                if (response.data?.branches) {
                    branchData = response.data.branches;
                } else if (response.data?.data) {
                    branchData = response.data.data;
                }

                if (Array.isArray(branchData)) {
                    console.log('Sample Branch Structure:', branchData[0]);
                    setBranchOptions(
                        branchData.map((branch, index) => {
                            const possibleLabels = [
                                branch.BranchName,
                                branch.branchName,
                                branch.Name,
                                branch.name,
                                branch.Branch_Name,
                                branch.branch_name,
                            ];
                            const branchLabel = possibleLabels.find(Boolean) || `Branch ${index + 1}`;

                            const possibleValues = [
                                branch.BranchNumber,
                                branch.branchNumber,
                                branch.Id,
                                branch.id,
                                branch.Branch_Id,
                                branch.branch_id,
                            ];
                            const branchValue = possibleValues.find((v) => v != null)?.toString() || `branch-${index}`;

                            return {
                                label: branchLabel,
                                value: branchValue,
                            };
                        })
                    );
                } else {
                    console.warn('Response data is not an array:', branchData);
                    setBranchOptions([]);
                    toast.warning('No branches available');
                }
            } catch (error) {
                console.error('Error fetching branch options:', error);
                toast.error('Failed to load branch list');
                setBranchOptions([]);
            }
        };

        fetchBranches();
    }, []);

    function handleVerifyPANClick() {
        if (!panValue || panValue.length !== 10) {
            toast.error('Please enter a valid 10-character PAN number');
            return;
        }

        const panLoadingToast = toast.loading('Verifying PAN...');
        axios
            .post(API_URL + '/AadharService/verifypancard?pan=' + panValue, {}, {
                timeout: 10000,
                headers: { 'Content-Type': 'application/json' },
            })
            .then((response) => {
                toast.dismiss(panLoadingToast);
                if (response && response.status === 200) {
                    toast.success('PAN details verified successfully');
                    setIsPANInvalid(false);
                    setIsPANVerified(true);
                } else {
                    throw new Error('Failed to verify PAN number');
                }
            })
            .catch((error) => {
                toast.dismiss(panLoadingToast);
                const errorMessage =
                    error.response?.data?.message || error.response?.data || 'Failed to verify PAN number';
                toast.error(errorMessage);
                setIsPANInvalid(true);
                setIsPANVerified(false);
                console.error('Error verifying PAN number:', error);
            });
    }

    function handleResendVerifyClick() {
        const adharno = adhaarValue.replace(/-/g, '');
        if (!adharno || adharno.length !== 12) {
            toast.error('Please enter a valid 12-digit Aadhaar number');
            return;
        }

        const resendLoadingToast = toast.loading('Resending OTP...');
        axios
            .post(API_URL + '/AadharService/generateaadharotp?aadharno=' + adharno, {}, {
                timeout: 10000,
                headers: { 'Content-Type': 'application/json' },
            })
            .then((response) => {
                toast.dismiss(resendLoadingToast);
                if (response.status === 200) {
                    setOtpData(response.data);
                    setIsAadharInvalid(false);
                    toast.success('OTP resent successfully');
                } else {
                    throw new Error('Failed to resend OTP');
                }
            })
            .catch((error) => {
                toast.dismiss(resendLoadingToast);
                const errorMessage = error.response?.data?.message || error.response?.data || 'Failed to resend OTP';
                toast.error(errorMessage);
                setIsAadharInvalid(true);
                console.error('Error resending OTP:', error);
            });
    }

function handleVerifyClick() {
        setLoading(true);
        const adharno = adhaarValue.replace(/-/g, '')
        axios.post(API_URL + '/AadharService/generateaadharotp?aadharno='+ adharno)
            .then(response => {

                if (response.status === 200) {
                    setOtpData(response.data)
                    setIsAadharInvalid(false);
                    setShowAdharVerify(true);
                    setLoading(false);
                } else {
                    toast.error("Failed to verify Aadhaar number");
                    throw new Error('Failed to verify Aadhaar number');
                }
            })
            .catch(error => {
                console.log("Response ====>", error.response.data);
                toast.error(error.response.data);
                setIsAadharInvalid(true);
                setLoading(false);
                console.error('Error verifying Aadhaar number:', error);
            });
    }

    const handlePanChange = (event) => {
        const input = event.target.value.toUpperCase();
        setPanValue(input);

        if (input.length === 10) {
            const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
            setIsPANInvalid(!panRegex.test(input));
            setIsPANVerified(false);
        } else {
            setIsPANInvalid(false);
            setIsPANVerified(false);
        }
    };

    const handleAadhaarVerificationStatus = (status) => {
        setAadharVerified(status);
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Backspace') {
            const index = event.target.selectionStart;
            if (index % 5 === 0) {
                event.target.setSelectionRange(index - 1, index - 1);
            }
        }
    };

    const handleAadhaarChange = (e) => {
        const inputValue = e.target.value;
        const sanitizedValue = inputValue.replace(/[^0-9]/g, '');
        const formattedValue = sanitizedValue.replace(/(.{4})/g, '$1-');
        const trimmedValue = formattedValue.slice(0, 14);
        setAdhaarValue(trimmedValue);
        setIsAadhaarEdited(true);
        setAadharVerified(false);
        setIsAadharInvalid(sanitizedValue.length > 0 && sanitizedValue.length !== 12);
    };

    const handleProceed = (e) => {
        e.preventDefault();

        if (!userData || !userData.phoneNumber) {
            toast.error('User data missing. Please register again.');
            console.error('UserData is null or missing phoneNumber:', userData);
            return;
        }

        if (!responseFromAPI) {
            toast.error('Please verify Aadhaar first');
            return;
        }

        if (!selectedBranch || !selectedBranch.label) {
            toast.error('Please select a valid branch');
            console.error('Selected Branch is invalid:', selectedBranch);
            return;
        }

        const payload = {
            firstName: responseFromAPI.data.full_name || '',
            dateOfBirth: responseFromAPI.data.dob || '',
            profileImage: responseFromAPI.data.profile_image || '',
            phoneNumber: userData.phoneNumber,
            gender: responseFromAPI.data.gender || '',
            panNumber: panValue.toUpperCase(),
            aadharNumber: responseFromAPI.data.aadhaar_number || '',
            BranchName: selectedBranch.label,
            isVideoKycDone: false,
            active: true,
            deleted: false,
        };

        console.log('Payload sent to API:', payload);

        const newCustomerEndPoint = '/Customer/createnewcustomer/';
        const proceedLoadingToast = toast.loading('Creating customer profile...');

        axios
            .post(API_URL + newCustomerEndPoint, payload, {
                timeout: 10000,
                headers: { 'Content-Type': 'application/json' },
            })
            .then((response) => {
                toast.dismiss(proceedLoadingToast);
                console.log('Customer Creation Response:', response.data);

  // ✅ NEW LOGS I ADDED:
            console.log('BranchName in response:', response.data.BranchName || response.data.branchName);
            console.log('Full Response Data:', JSON.stringify(response.data, null, 2));


                setUserData({ ...response.data, BranchName: selectedBranch.label });
                setAdharData(responseFromAPI);
                sessionStorage.setItem(
                    'responseData',
                    JSON.stringify({
                        ...response.data,
                        BranchName: selectedBranch.label,
                    })
                );
                navigate('/docupload');
            })
            .catch((error) => {
                toast.dismiss(proceedLoadingToast);
                const errorMessage =
                    error.response?.data?.message || error.response?.data || 'Failed to create customer profile';
                toast.error(errorMessage);
                console.error('Error creating new customer:', error);
            });
    };

    useEffect(() => {
        if (
            panValue &&
            adhaarValue &&
            checkbox1Checked &&
            checkbox2Checked &&
            isPANVerified &&
            aadharVerified &&
            selectedBranch?.label
        ) {
            setButtonDisabled(false);
        } else {
            setButtonDisabled(true);
        }
    }, [panValue, adhaarValue, checkbox1Checked, checkbox2Checked, isPANVerified, aadharVerified, selectedBranch]);

    useEffect(() => {
        if (adhaarValue.length !== 14) {
            setIsVerified(false);
        }
    }, [adhaarValue]);

    useEffect(() => {
        if (isVerified && isAadhaarEdited) {
            setIsVerified(false);
        }
    }, [isVerified, isAadhaarEdited]);

    return (
        <div className='welcome-container'>
            <div className='welcome-holder'>
                <h2>{t('welcome')} 👋</h2>
                <p>{t('pleaseProvideYourDetails')}</p>
                <form>
                    <div className='form-field' style={{ justifyContent: 'flex-start' }}>
                        <input
                            type='text'
                            placeholder={t('panNumber')}
                            value={panValue.toUpperCase()}
                            onChange={handlePanChange}
                            maxLength={10}
                        />
                        {isPANInvalid && <p style={{ color: 'red', whiteSpace: 'nowrap' }}>Invalid PAN</p>}
                        {panValue.length === 10 && !isPANVerified && !isPANInvalid && (
                            <p className='verify-text' onClick={handleVerifyPANClick}>
                                {t('verify')}
                            </p>
                        )}
                        {isPANVerified && <img src={verifiedIcon} alt='Verified' className='verify-icon' />}
                    </div>
                    <div className='form-field'>
                        <input
                            type='text'
                            placeholder={t('aadhaarNumber')}
                            value={adhaarValue}
                            onChange={handleAadhaarChange}
                            onKeyDown={handleKeyDown}
                            maxLength={14}
                        />
                        {isAadharInvalid && <p style={{ color: 'red', whiteSpace: 'nowrap' }}>Invalid Aadhar</p>}
                        {adhaarValue.length === 14 && !aadharVerified && !isAadharInvalid && (
                            <p className='verify-text' onClick={handleVerifyClick}>
                                {loading ? t('verifying') : t('verify')}
                            </p>
                        )}
                        {aadharVerified && <img src={verifiedIcon} alt='Verified' className='verify-icon' />}
                    </div>

                    <Dropdown
                        title={t('selectBranch')}
                        options={branchOptions}
                        selectedOption={selectedBranch}
                        onSelect={setSelectedBranch}
                        className="branch-dropdown"
                        style={{ width: '100%', justifyContent: 'flex-start' }}
                    />

                    <div className='checkbox-field'>
                        <input
                            type='checkbox'
                            checked={checkbox1Checked}
                            onChange={(e) => setCheckbox1Checked(e.target.checked)}
                        />
                        <p className='consent-para'>{t('aadhaarConsent')}</p>
                    </div>
                    <div className='checkbox-field'>
                        <input
                            type='checkbox'
                            checked={checkbox2Checked}
                            onChange={(e) => setCheckbox2Checked(e.target.checked)}
                        />
                        <p className='consent-para'>{t('bankAllowCheckCibilScore')}</p>
                    </div>
                    <span className='safety-note'>
                        <AiFillSafetyCertificate />
                        {t('yourDataIsSafeWithUs')}
                    </span>
                    <button className='welcome-btn' disabled={buttonDisabled} onClick={handleProceed}>
                        {t('proceedToDocuments')}
                    </button>
                </form>
            </div>
            {showAdharVerify && (
                <AdharVerify
                    handleAPIResponse={handleAPIResponse}
                    handleVerifyClick={handleVerifyClick}
            otpData={otpData.data}
                    adhaarNumber={adhaarValue.replace(/-/g, '')}
                    updateAadharVerificationStatus={handleAadhaarVerificationStatus}
                    setShowAdharVerify={setShowAdharVerify}
                    handleResendVerifyClick={handleResendVerifyClick}
                />
            )}
        </div>
    );
}

export default Welcome;